import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({ 
  title, 
  description,
  canonicalUrl,
  keywords
}) => {
  return (
    <Helmet>
      <title>{title || 'ECOSOFT - Sistema OPUS para Ingeniería de Costos'}</title>
      <meta 
        name="description" 
        content={description || 'ECOSOFT - Soluciones de vanguardia en tecnologías de información. Creadores de OPUS, sistema líder en ingeniería de costos, presupuestación y control de obra.'} 
      />
      <meta 
        name="keywords" 
        content={keywords || 'OPUS, ingeniería de costos, presupuestos, control de obra, software construcción, ERP construcción, ECOSOFT'} 
      />
      <link rel="canonical" href={canonicalUrl || 'https://www.ecosoft.com.mx'} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title || 'ECOSOFT - Sistema OPUS para Ingeniería de Costos'} />
      <meta property="og:description" content={description || 'ECOSOFT - Soluciones de vanguardia en tecnologías de información. Creadores de OPUS, sistema líder en ingeniería de costos.'} />
      <meta property="og:url" content={canonicalUrl || 'https://www.ecosoft.com.mx'} />
      <meta property="og:site_name" content="ECOSOFT" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || 'ECOSOFT - Sistema OPUS para Ingeniería de Costos'} />
      <meta name="twitter:description" content={description || 'ECOSOFT - Soluciones de vanguardia en tecnologías de información. Creadores de OPUS, sistema líder en ingeniería de costos.'} />
    </Helmet>
  );
}; 